import { useParams } from "react-router-dom";
import Dashboard from "screens/components//Dashboard";

function PbaasAppAnalytics() {
  const { organisationId, appId } = useParams();
  return <Dashboard organisationId={organisationId} appId={appId}></Dashboard>;
}

export default PbaasAppAnalytics;
